import { useMutation } from 'react-query';
import { getAllCustomerEventByLicenseCountAsync } from '../../index';

export const useGetAllCustomerEventByLicenseCountAsync = () =>
  useMutation(getAllCustomerEventByLicenseCountAsync);
